import { Button, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { updateArtifact } from '../../../services/artifactService'
import { SCREENING_STATE, SCREENING_TAG } from '../util/artifactsConstants'

export default function ApproveArtifactOverlay({ artifactId, onSuccess, ...overlay }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()

  const submitOnClick = async () => {
    overlay.close()
    try {
      await updateArtifact({
        id: artifactId,
        ID: artifactId,
        screeningState: SCREENING_STATE.APPROVED,
        screeningTag: SCREENING_TAG.NOT_SET,
      })
      ok(t('success', 'Success'))
      onSuccess && onSuccess()
    } catch (err) {
      error(t('artifacts.error.errorApprovingArtifact', 'Error approving artifact'), err)
    }
  }

  return (
    <DialogOverlay title={t('artifacts.approve', 'Approve')} {...overlay}>
      <Paragraph size="sm">
        {t('artifacts.approveConfirmation', 'Are you sure you want to approve this artifact?')}
      </Paragraph>
      <DialogOverlayActions>
        <Button onClick={submitOnClick} emphasis="high">
          {t('action.submit', 'Submit')}
        </Button>
        <Button onClick={overlay.close}>{t('action.cancel', 'Cancel')}</Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
